import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Fab, Tooltip } from '@material-ui/core';
import { Check as CheckIcon } from '@material-ui/icons';

class FormCheckButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        addKeyValue: PropTypes.func.isRequired,
    };

    static defaultProps = {};

    render() {
        const { addKeyValue, classes } = this.props;

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title={Translator.translate('general.add')} placement="top">
                    <Fab
                        aria-label={Translator.translate('general.add')}
                        className={`${classes.btnEdit} ${classes.fabSave}`}
                        size="small"
                        onClick={addKeyValue}
                    >
                        <CheckIcon className={classes.icon} />
                    </Fab>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    fabSave: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    btnEdit: {
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30,
        },
    },
    icon: {
        fontSize: '1.2rem',
    },
});

export default withStyles(styles, { withTheme: true })(FormCheckButton);



// WEBPACK FOOTER //
// ./data/components/FormCheckButton.js